// clipboardHelper.js

// Function to copy text to clipboard
export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(
    () => {
      // Success action
      alert('Text copied to clipboard!');
    },
    (err) => {
      // Error handling
      alert('Could not copy text: ', err);
    },
  );
};
